import useAuth from './auth/useAuth.js';
import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { useParams, useLocation } from 'react-router-dom';
const Notice = () => {
    let auth = useAuth();
    let location = useLocation();
    const [origin, setOrigin] = useState('/');
    const [processing, setProcessing] = useState(false);
    useEffect(() => {
        // remember where I was before redirected to login
        var querystr = new URLSearchParams(location.search).get("origin");
        if (querystr != null) {
            setOrigin(querystr);
        }

    }, [location]);
    useEffect(() => {
        sessionStorage.setItem("redirectPath", origin);
    }, [origin]);
    const login = () => {
        console.log("login");
        setProcessing(true);
        auth.signin();
        //auth.signin().then(response => {
        //    console.log("then");
        //    window.location = process.env.PUBLIC_URL + origin;
        //   setProcessing(false);
        //}).catch(error => {
        //    console.log(error);
        //    setProcessing(false)
        //});
    };
    return (
        <React.Fragment>
            <Typography variant="h1">IP Notice and Disclaimer</Typography>
            <Typography variant="body1" component="p">EO Online has been designed for educational purposes only and should not, under any circumstances, be regarded as or substituted for legal advice.</Typography>

            <Typography variant="h2">Intellectual Property and Use of EO Online</Typography>
            <Typography variant="body1" component="p">
                Use of EO Online is restricted to participating universities as a resource for staff training and referral within their university.   </Typography>
            <Typography variant="body1" component="p">
                Use by students is permitted for purposes such as pre-work-placement training, to aid grievance resolution or to prevent discrimination and harassment. However, EO Online may not be delivered as examinable course content.</Typography>
            <Typography variant="body1" component="p">
                Please <a href="mailto:tod-team@uow.edu.au">contact us</a> if you are in doubt about permitted usage of EO Online.
            </Typography>
            <Typography variant="body1" component="p">
                The information you provide as part of this registration is collected and held by the University of Wollongong for the purpose of:
            </Typography>
            <ul>
                <Typography variant="body2" component="li">Processing your registration to use EO Online</Typography>
                <Typography variant="body2" component="li">identifying you to enable your continued use of EO Online and</Typography>
                <Typography variant="body2" component="li">providing completion data to your University.</Typography>                
            </ul>
            <Typography variant="body1" component="p">
                Completion of EO Online may be a mandatory requirement at your University. If you do not provide all the requested information you will not be able to register with, or use EO Online.
            </Typography>
            <Typography variant="body1" component="p">The information you supply will be downloadable by authorised officers from your University. It will be used by your University to identify you and to record that you have completed EO Online and when you completed it.
            </Typography>
            <Typography variant="body1" component="p">
                You have both a right of access to the personal information we hold about you and to ask us to correct it if it is inaccurate or out of date.
            </Typography>
            <Typography variant="body1" component="p">
                The University of Wollongong's Privacy Policy explains our commitment to the protection of your personal information and can be found at <a href="http://www.uow.edu.au/about/privacy" target="_blank">http://www.uow.edu.au/about/privacy</a>.
            </Typography>
            <Button color="primary" onClick={login} disabled={processing} variant="contained" aria-label="I have read and understood, proceed to login">{processing ? "Please wait while you're being redirected..." : "I have read and understood"}</Button>
        </React.Fragment>
    );
}

export default Notice;